export { default } from './NProgressBar';